import {Dispatch, SetStateAction} from 'react'

export type ID = undefined | null | number | string

export type PaginationState = {
  page?: number
  items_per_page?: 5 | 10 |20 | 30 | 50 | 100
  links?: Array<{label: string; active: boolean; url: string | null; page: number | null}>
}

export type WatandarOnlinePaginationState = {
  page?: number
  first_page_url?: string
  from?: number
  last_page?: number
  links?: Array<{label: string; active: boolean; url: string | null; page: number | null}>
  next_page_url?: string
  items_per_page?: 5 | 10 |20 | 30 | 50 | 100
  prev_page_url?: string | null
  to?: number
  total?: number
}

export type SortState = {
  sort?: string
  order?: 'asc' | 'desc'
}

export type FilterState = {
  filter?: unknown
}

export type SearchState = {
  search?: string
}
export type DateSearchState = {
  dates?: any
}
export type WatandarOnlineResponse<T> = {
  success?: boolean
  code?: number
  message?: string
  data: {[key: string]: T}
  payload?: {
    pagination?: WatandarOnlinePaginationState
  }
}

export type Response<T> = {
  success?: boolean
  code?: number
  message?: string
  data: T
  payload?: {
    message?: string
    errors?: {
      [key: string]: Array<string>
    }
    pagination?: PaginationState
  }
}

export type QueryState = PaginationState & SortState & FilterState & SearchState
export type KhwarnetQueryState = WatandarOnlinePaginationState & SortState & FilterState & SearchState & DateSearchState

export type QueryRequestContextProps = {
  state: QueryState
  updateState: (updates: Partial<QueryState>) => void
}

export type KhwarnetQueryRequestContextProps = {
  state: KhwarnetQueryState
  updateState: (updates: Partial<KhwarnetQueryState>) => void
}

export const initialQueryState: QueryState = {
  page: 1,
  items_per_page: 20,
}
export const initialQueryStateWatandarOnline: KhwarnetQueryState = {
  page: 1,
  items_per_page: 20,
}

export const initialQueryRequest: QueryRequestContextProps = {
  state: initialQueryState,
  updateState: () => {},
}

export const initialQueryRequestWatandarOnline: KhwarnetQueryRequestContextProps = {
  state: initialQueryStateWatandarOnline,
  updateState: () => {},
}

export type QueryResponseContextProps<T> = {
  response?: Response<Array<T>> | undefined
  refetch: () => void
  isLoading: boolean
  query: string
}

export type WatandarOnlineQueryResponseContextProps<T> = {
  response?: WatandarOnlineResponse<Array<T>> | undefined
  refetch: () => void
  isLoading: boolean
  query: string
}

export const initialQueryResponse = {refetch: () => {}, isLoading: false, query: ''}

export type ListViewContextProps = {
  selected: Array<ID>
  onSelect: (selectedId: ID) => void
  onSelectAll: () => void
  clearSelected: () => void
  // NULL => (CREATION MODE) | MODAL IS OPENED
  // NUMBER => (EDIT MODE) | MODAL IS OPENED
  // UNDEFINED => MODAL IS CLOSED
  itemIdForUpdate?: ID
  setItemIdForUpdate: Dispatch<SetStateAction<ID>>
  isAllSelected: boolean
  disabled: boolean
}

export const initialListView: ListViewContextProps = {
  selected: [],
  onSelect: () => {},
  onSelectAll: () => {},
  clearSelected: () => {},
  setItemIdForUpdate: () => {},
  isAllSelected: false,
  disabled: false,
}
